export default {
  $vuetify: {
    badge: 'Badge',
    close: 'Close',
    dataIterator: {
      noResultsText: 'No matching records found',
      loadingText: 'Loading items...',
    },
    dataTable: {
      itemsPerPageText: 'Rows per page:',
      ariaLabel: {
        sortDescending: 'Sorted descending.',
        sortAscending: 'Sorted ascending.',
        sortNone: 'Not sorted.',
        activateNone: 'Activate to remove sorting.',
        activateDescending: 'Activate to sort descending.',
        activateAscending: 'Activate to sort ascending.',
      },
      sortBy: 'Sort by',
    },
    dataFooter: {
      itemsPerPageText: 'Items per page:',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} of {2}',
    },
    datePicker: {
      itemsSelected: '{0} selected',
      nextMonthAriaLabel: 'Next month',
      nextYearAriaLabel: 'Next year',
      prevMonthAriaLabel: 'Previous month',
      prevYearAriaLabel: 'Previous year',
    },
    noDataText: 'No data available',
    carousel: {
      prev: 'Previous visual',
      next: 'Next visual',
      ariaLabel: {
        delimiter: 'Carousel slide {0} of {1}',
      },
    },
    calendar: {
      moreEvents: '{0} more',
    },
    fileInput: {
      counter: '{0} files',
      counterSize: '{0} files ({1} in total)',
    },
    timePicker: {
      am: 'AM',
      pm: 'PM',
    },
    pagination: {
      ariaLabel: {
        wrapper: 'Pagination Navigation',
        next: 'Next page',
        previous: 'Previous page',
        page: 'Goto Page {0}',
        currentPage: 'Current Page, Page {0}',
      },
    },
    rating: {
      ariaLabel: {
        icon: 'Rating {0} of {1}',
      },
    }
  },
  common: {
    loading: 'Loading...',
    maximum_text: 'This field must be {length} characters or less',
    activation: 'Video Contents Accessible Account',
    action: 'Action',
    email_invalid: 'Invalid Email',
    timezone: 'Timezone',
    edit: 'Edit',
    confirm: 'Confirm',
    confirmation: 'Confirmation',
    reject: 'Reject',
    draft: 'Draft',
    save: 'Save',
    cancel: 'Cancel',
    search: 'Search',
    require: 'This field is required',
    required: 'Required',
    invalid: 'Invalid',
    invalid_file_format: 'Invalid file format',
    auth_error: 'Something went wrong in the authentication process. Message: {msg}',
    no_role_error: 'Oops! You must be an certified trainer or salesperson of the company in order to use the system. Please contact your department or HR to update your information',
    unknown_error: 'Unknown Error Occurred. Please contact its@achievement.co.jp',
    network_not_reach_error: 'Sorry, something went wrong with request or connection',
    network_backend_error: 'Sorry, something is wrong with the request which makes the server cannot serve properly. Please try again.',
    network_backend_duplicate_error: 'Resource conflict',
    network_generic_error: 'Oops! Something went wrong. Message: {msg}',
    network_not_found_error: 'Oops! The resource you are trying to get is not available.',
    network_not_allow: 'Sorry, either you are not allowed to view the resource or that you must login first. Please try again after re-login.',
    network_unprocessable: 'Sorry, the input given is invalid. ({msg})',
    validate_dob_year: 'Invalid year',
    validate_dob_month: 'Invalid month',
    validate_dob_day: 'Invalid day',
    close: 'Close',
    page_denied_title: 'Page Access Denied!',
    page_denied_desc: 'Sorry. You do not have access to this page. Please ask admin to assign {pageName} page to {groupName} group.',
    phone_invalid: 'Phone number is invalid.',
    dob_invalid: 'Date of birth is invalid.',
    pre_course_report: 'Pre-course Report',
    post_course_report: 'Post-course Report',
    pre_course: 'Pre-course',
    post_course: 'Post-course'
  },
  employee: {
    apply: 'Apply',
    unassigned: 'Unassigned',
    click_to_disable: 'Click to disable',
    click_to_enable: 'Click to enable',
    not_in_group: 'Employee have to be in any user group to turn on allow login',
    user_group: 'QUATS Permission Group',
    is_can_login: 'Is can login?',
    permission_group_assignment: 'Permission Group Assignment',
    no_csv: 'Please select CSV file',
    name: 'Employee Name',
    name_kana: 'Employee Name (Furigana)',
    id: 'ID',
    disclosure_level: 'Disclosure level',
    title: 'Video Contents Viewing Setting',
    create_employee: 'Create MARC Account for Employee',
    surname: 'Surname',
    firstname: 'Name',
    surname_kana: 'Surname (Kana)',
    firstname_kana: 'Name (Kana)',
    dob: 'Date of birth',
    dob_title: 'Date of birth',
    dob_year: 'YYYY',
    dob_month: 'MM',
    dob_day: 'DD',
    sex: 'Sex',
    mail_address: 'Mail Address',
    phone_number: 'Phone Number',
    visible_teaching_material: 'Assigned Video Contents',
    action: 'Grant Viewing Rights',
    pagination_text: 'Employees displayed per page:',
    create_with_csv: 'Click here for bulk creation (CSV Upload)',
    create_with_csv_shortened: 'Click here for bulk creation',
    active: 'Active',
    enable: 'Enable',
    detail: 'Detail',
    search_success_message: 'Data loaded successfully',
    csv_title: 'Data',
    csv_title_valid: '\'s data are listed down below',
    csv_title_invalid: '\'s header is not match',
    upload_csv: 'Upload CSV here',
    csv_no_data: ' has no data',
    download_template: 'Download the template and import the file',
    individual_creation: 'Click here to create individually',
    download: 'Download Template',
    change_viewing_right_title: 'Viewing Right',
    corporate_activated: 'Corporate account has been activated successfully.',
    corporate_deactivated: 'Corporate account has been deactivated successfully.',
    phone_3_digits: 'The input should be positive and not exceed 3 characters',
    phone_4_digits: 'The input should be positive and not exceed 4 characters',
    email_rule: 'Must be an valid email',
    customer_id: 'Customer ID',
    download_award: 'Download "Human Resource Development Mechanism" documentation',
    login_toggle_success: 'Successfully updated permission group',
    activate_login: 'Successfully activate login account',
    deactivate_login: 'Successfully deactivate login account',
    note: '※If you do not have an Achievement MARC account, please select "Create a MARC account" → "Link with QUATS" and your name will appear in the list on this page (video content viewing settings).\n' +
      '※If you have applied for the Achievement Technology course, you already have a MARC account.\n' +
      '※If you are not sure whether the employee in question has a MARC account, please proceed by clicking the "Create MARC Account" button.',
    create_employee_marc_account: 'Create MARC Account for Employee',
    dialog_note: '※After this application, a MARC account will be issued within two business days and a MARC ID and password will be sent to the employee\'s email address. After an employee logs in to MARC and presses the information disclosure button on the user information change screen, the employee will be added to the QUATS employee list.'
  },
  detail: {
    fullName: 'Full name',
    employee_info: 'Employee Information',
    company_info: 'Company Information',
    company_name: 'Company\'s name',
    max_corporate: 'Max. Corporate',
    available_corporate: 'Remaining Accounts Available for Video Contents',
    name: 'Video Content Name',
    parent_company_program: 'List of Available Video Contents',
    active: 'Active',
    enable: 'Enable',
    max_view: 'Maximum View',
    available: 'Remaining Viewing Rights',
    can_view: 'Accessibility',
    warning: 'You will permanently allow current employee to see this program',
    no_available_corporate: 'There is no available corporate account left'
  },
  navigation_list: {
    home_page: 'Home',
    employee: 'Video Contents Viewing Setting',
    employee_seminar_info: 'Employee Attendance History',
    manual: 'User Manual',
    user_group: 'QUATS Permission Group Setting',
    login_account: 'QUATS Permission Group Assignment',
    back: 'Back',
    course_report: 'Employee Attendance Report'
  },
  login: {
    what_is_quats: 'What is the "Corporate Member Site [QUATS]?',
    quats_desc_1: 'QUATS stands for Quality Company Training Management System, an Internet service that aims to support employee training to realize Quality Company.',
    quats_desc_2: 'QUATS is available to Quality Company Club Standard and Starter member companies.',
    marc_desc_3: 'MARC is a service for club members and JPSA members.',
    detail: 'Click here for details',
    privacy_policy: 'Privacy Policy',
    quats_id: 'QUATS ID or Email',
    quats_id_required: 'Please fill in your QUATS ID or Email',
    quats_id_invalid: 'QUATS ID or Email is invalid',
    password: 'Password',
    password_required: 'Please fill in your password',
    forget_password: 'Forget Password',
    password_reset: 'Password Reset',
    password_reset_instruction_1: 'Please enter your QUATS ID or Email',
    password_reset_instruction_2: 'After that, click the "Reset" button',
    reset: 'Reset',
    back_to_login: 'Back to ManageAccount',
    login: 'Log In',
    to_marc: 'Individual member site',
    credential_not_match: 'Credentials not match',
    must_be_person: 'Must be person type',
    new_password: 'New Password',
    confirm_new_password: 'Confirm new password',
    new_password_instruction_1: 'Fill in your new password, and confirm new password',
    new_password_instruction_2: 'After that, please click on the "Set New Password" button',
    new_password_required: 'New password required',
    confirm_new_password_required: 'Confirm new password required',
    set_new_password: 'Set New Password',
    must_be_numeric: 'QUATS ID must be numeric',
    password_not_match: 'Password does not match',
    reset_link_sent: 'Reset link has been sent!',
    reset_info: 'A link for resetting the password has been sent to your email. Please check your email inbox and click on the link to proceed with setting a new password.',
    successfully_reset: 'Password has been reset successfully. Redirecting back to login page...',
    minimum_six: 'Password must contain at least 6 characters',
    login_via_marc: 'Enter via MARC Login Account',
    or: 'OR'
  },
  error_message: {
    not_found: 'User with this ID does not exist',
    something_went_wrong: 'Something Went Wrong, Please Try Again'
  },
  homepage: {
    corporate_content: 'Corporate Content',
    member_company_information: 'Employee List',
    company_name: 'Company Name',
    enterprise_id: 'Enterprise ID',
    membership_status: 'Membership Status',
    membership_status_change: 'Membership Status Change',
    employee_registration_status: 'Available Accounts for Video Contents',
    for_first_time_customer: 'First time user',
    register_employee: 'Configure Viewing Setting for Video Contents',
    quat_user_guide: 'QUATS User Guide',
    membership_start_date: 'Start Date',
    membership_end_date: 'End Date',
    membership_renewal_date: 'Renewal Date',
    update_membership: 'Update Membership',
    change_membership_category: 'Change of Membership Status',
    update_description: 'Description',
    current_membership_category: 'Current Membership Category',
    increase_employee: 'Increase Employee',
    upgrade_membership: 'Upgrade Membership',
    upgrade_membership_button: 'Upgrade Membership',
    reduce_employee: 'Reduce Employee',
    reduce_employee_form: 'Reduce Employee',
    downgrade_membership: 'Downgrade Membership',
    downgrade_membership_form: 'Downgrade Membership Status',
    suspend_membership: 'Suspend Membership',
    suspend_membership_form: 'Change Membership Status to Suspended',
    cancel_membership: 'Cancel Membership',
    cancel_membership_form: 'Change Membership Status to Cancelled',
    remark: 'Remark:',
    choose_new_membership_plan: 'Please choose a new membership plan:',
    choose: 'Choose',
    optional: 'Optional',
    back: 'Back',
    close: 'Close',
    submit: 'Submit',
    warning: 'Warning',
    upgrade_membership_category: 'UPGRADE MEMBERSHIP',
    upgrade_membership_category_subtitle: 'You may upgrade your current membership classification.',
    upgrade_membership_category_heading_1: 'Starter Membership → Standard Membership',
    upgrade_membership_category_heading_1_content_1: 'You can upgrade your membership category to Standard Membership on the same day or the following month.',
    upgrade_membership_category_heading_1_content_2: 'The monthly prorated membership fee for the period until the expiration of the Starter membership can be applied to other products and services or refunded.',
    upgrade_membership_category_heading_1_content_3: 'For more information about the benefits of Standard Membership, please visit the official QCC website.',
    upgrade_membership_category_heading_2: 'Standard Member -> Standard Member (increased account)',
    upgrade_membership_category_heading_2_content_1: 'You can increase the number of accounts to view online training programs from the current month or the following month.',
    upgrade_membership_category_heading_2_content_2: 'The monthly prorated membership fee for the period up to the expiration of your current membership can be applied to other products and services or refunded.',
    upgrade_membership_category_action_btn: 'Proceed to Upgrade Application Process',
    upgrade_membership_category_contact_us_msg: 'If you have any questions or concerns about upgrades, please contact us.',
    downgrade_suspension_withdrawal_membership: 'Downgrades, Suspensions and Withdrawals Process',
    downgrade_suspension_withdrawal_membership_category: 'Downgrades, Suspensions and Withdrawals Process',
    downgrade_suspension_withdrawal_membership_category_subtitle_1: 'If you complete the required procedures by the 10th of the month prior to the last month of the membership period of validity, your membership will be changed to the new category when the current membership period expires.',
    downgrade_suspension_withdrawal_membership_category_subtitle_2: 'If the procedure is completed after the above date, the change will be made when the membership expires the following year.',
    downgrade_suspension_withdrawal_membership_category_subtitle_3: 'If you are considering downgrading, suspending, or canceling your membership, please contact us well in advance.',
    downgrade_suspension_withdrawal_membership_heading_1: 'Downgrade',
    downgrade_suspension_withdrawal_membership_heading_1_content_1: 'You can reduce the number of viewing accounts for your online training program or change to a starter membership.',
    downgrade_suspension_withdrawal_membership_heading_2: 'Suspension',
    downgrade_suspension_withdrawal_membership_heading_2_content_1: 'Temporary suspension of membership services is available. (Suspension fee: 13,200 yen per year (tax included)).',
    downgrade_suspension_withdrawal_membership_heading_2_content_2: 'If you re-convert from a recess to a Starter or Standard membership, you will be able to use the online training programs purchased prior to the recess in the same manner as you did prior to the recess.',
    downgrade_suspension_withdrawal_membership_heading_2_content_3: 'During the period of inactivity, members will not be able to use the general membership services, but the QCC Newsletter will be sent to them periodically.',
    downgrade_suspension_withdrawal_membership_heading_3: 'Withdrawal',
    downgrade_suspension_withdrawal_membership_heading_3_content_1: 'You may cancel your membership from the membership service.',
    downgrade_suspension_withdrawal_membership_heading_3_content_2: 'If you cancel your membership and then rejoin as a Starter or Standard member, all online training programs must be purchased again at the regular price. We recommend that you cancel your membership if you intend to continue using the online training programs you have purchased.',
    downgrade_suspension_withdrawal_membership_contact_us_msg: 'If you would like to change your membership classification or consult with us, please contact us.'
  },
  program_list_table: {
    available_list: 'List of Available Video Contents',
    video_content_name: 'Video Content Name',
    total_view: 'Maximum Number of Viewing Rights Available',
    assigned_view: 'Number of Viewing Rights Set',
    remaining_view: 'Number of View Rights Remaining'
  },
  group: {
    title: 'QUATS Permission Group Setting',
    user_group_name: 'Permission Group Name',
    user_group_name_english: 'User group\'s name English',
    user_group_description: 'Permission Group Description (Features Available To That Group)',
    user_group_description_english: 'User group\'s description English',
    page_group_name: 'Page group\'s name',
    page_group_description: 'Page group\'s description',
    page_group_listing: 'Page group list for {name} (ID: {id})',
    create_user_group: 'Create Original Permission Group',
    create: 'Create',
    user_group_create_success: 'Successfully created Permission Group',
    assign_module: 'Pages that Permission Group「{name}」(ID: {id}) can access',
    assign_module_to_user_group: 'Assign module to Permission Group',
    assign: 'Edit',
    group_information: 'Group Information',
    user_group_page_updated_success: 'Page group has been updated.',
    unchangeable: 'Default',
    note: 'This page allows you to configure QUATS permission groups.\n' +
      'For each permission, you can set the scope of viewing and editing on QUATS, such as 「Video Contents Viewing Setting」 and 「Employee Attendance Report」page.\n' +
      '・The initial settings are 「Administrator」,「Supervisor」, and「Human Resource」 permission groups.\n' +
      '・You can set who should be assigned to which permission group on the 「QUATS Permission Group Assignment」 page.'
  },
  login_account: {
    title: 'QUATS Permission Group Assignment',
    assign_user_to_group: 'Permission Group Assignment',
    assign_user_to_group_success: 'Assign user to group successfully',
    desc_1: 'Employees who can act as admin or manager can now log into QUATS using their MARC Account if they have a user group and login access is enabled.',
    desc_2: 'On login page, please click on "MARCログインアカウントで入る" button to login.',
    pagination_text: 'Employees displayed per page:'
  },
  employee_seminar_info: {
    title: 'Employee Attendance History',
    name: 'Employee Name',
    name_kana: 'Employee Name (Furigana)',
    atc: 'Achievement Technology Course (ATC)',
    re_atc: 'Achievement Technology Course reattend (ATC reattend)',
    dc: 'Dynamic Course (DC)',
    dac: 'Dynamic Advance Course (DAC)',
    ppc: 'Peak Performance Course (PPC)',
    ptp: 'Pro-speaker Training Program (PTP)',
    atc_re: 'Achievement Technology Course (Retake {num})',
    customer_id: 'Customer ID',
    tab_road_top: 'Road to the Top Series',
    tab_quality_company: 'Quality Company Series',
    pagination_text: 'Employees displayed per page:',
    note: '※The dates in red are the scheduled dates. \n' +
      '※The number next to the schedule is the number of times the course was taken. \n' +
      '※Click on an employee\'s name to view details of their course history.\n' +
      '※For the "Road to the Top" series, those who have registered as employees by September 29th will be shown the information after the end of October.\n' +
      '※Regarding the "Quality Company Series", the history from the date the company registration was completed on the system will be displayed. \n' +
      '※Employees with parentheses next to their names are professional speakers. \n' +
      'APS = Associate Professional Speaker\n' +
      'BPS = Basic Professional Speaker\n' +
      'SPS = Senior Professional Speaker\n' +
      'EPS = Executive Pro Speaker\n' +
      'MPS = Master Professional Speaker'
  },
  employee_seminar_detail: {
    first_attend: 'First Attend',
    reattended: 'Retake {index} times',
    attended: 'Attended',
    attendance_info: {
      title: 'Seminar Attendance Information',
      road_to_top_attendance_status: '\'Road to The Top\' Series Attendance Status',
      course_name_header: 'Course Name',
      attendance_status_header: 'Attendance Status',
      standard_atc_attendance_status: 'Standard Course/Achievement Technology Course Attendance Status',
      standard_atc_attendances_header: 'Attendances'
    },
    course_report: 'Course Report',
    attendance_status_note: '※In some cases, you may not able to check the attendance status information before October 2005.',
    attendance_history: {
      title: 'Seminar Attendance History (Other than \'Road to The Top\') Series',
      table_info: 'Questionnaires/Follow Counseling Sheets can only be viewed on this page if they were submitted through MARC.',
      schedule_header: 'Schedule',
      venue_header: 'Venue',
      seminar_name_header: 'Seminar Name'
    },
    assistant_history: {
      title: 'Assistant History',
      table_info_1: '※In October 2021, The system for accepting seminar assistants was changes. This history display function is only for those accepted by the new system.',
      table_info_2: 'Seminar assistants before December 2021 and some seminar assistants in the transition period will not be displayed.',
      situation_header: 'Situation'
    },
  },
  course_report: {
    title: 'Employee Attendance Report Setting',
    pdf_download: 'PDF Download',
    reattended: '【Retake {index} times】',
    first_attend: '【First Attend】',
    seminar_date: 'Seminar\'s date：',
    seminar_information: 'Seminar Information',
    question: 'Q',
    fix_question: 'Fixed question',
    required: 'Required',
    custom_question: 'If you would like to add Q{number}, please set the question',
    date_of_attendance: 'Date',
    submitted: 'Submitted',
    not_submitted: 'Not submitted',
    send_mail: 'Send mail',
    original_question: 'Original Question',
    send_confirmation: 'Are you sure you want to send the reminder email?',
    send_success_message: 'Email has been sent',
    no_employee_text: 'There are no employees scheduled to take the course',
    page_intro: 'This is the settings screen for employee attendance reports.',
    page_instruction: '▼ What you can do on this screen\n' +
      '          <p>It is possible to "Set report function ON/OFF", "Edit question content", "Check submission status", and "Send reminder email to those who have not submitted".</p>\n' +
      '          ※How to check the report contents\n' +
      '          <p>You can check by clicking on the "Hamburger Menu (三) on the top left" → "Employee Attendance History" → "\'Road to the Top\' Series" → "Report" button for the relevant employee.</p>',
    attendee_table_note: '※The list is displayed for one month before and after the seminar date.<br>\n' +
      '※If the attendance report function is set to 「OFF」, the attendance report function will not be available.'
  }
}
